import React from "react";
import {
  Box,
  Typography,
  Button,
  IconButton,
} from "@mui/material";
import { ACCEPTED, IC_RABBETUSER_LOGO, IC_SHARE_REFERRAL, LOGO_FULL_RED } from "../../constants/images";
import { COL_WHITE } from "../../constants/colors";

const RedemptionCard = ({ offerData, isEdit, promoType }) => {
  const formatDate = (date) => {
    const d = new Date(date);
    const month = ("0" + (d.getMonth() + 1)).slice(-2);
    const day = ("0" + d.getDate()).slice(-2);
    const year = d.getFullYear();
    return `${month}/${day}/${year}`;
  };

  const kFormatDate = (dateStr) => {
    const date = new Date(dateStr);
    const day = date.toLocaleString("en-US", { weekday: "short" });
    const month = date.toLocaleString("en-US", { month: "short" });
    const dayNum = date.getDate();
    const ordinal =
      ["th", "st", "nd", "rd"][
        (dayNum % 10 > 3 || ~~(dayNum % 100 / 10) === 1) ? 0 : dayNum % 10
      ] || "th";
    const time = date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
    return `${day} ${month} ${dayNum}${ordinal} ${time}`;
  };

  const expiredDate =
    isEdit
      ? promoType === "Karat"
        ? kFormatDate(offerData?.gameTime)
        : formatDate(offerData?.sponsorDetails?.expiredDate)
      : promoType === "Karat"
      ? kFormatDate(offerData?.gameTime)
      : offerData?.sponsorDetails?.expiredDate;

  return (
    <Box
      sx={{
        justifyContent:'center',
        alignItems:'center',
        background: "linear-gradient(to right, #242329, #28262e)",
        color: "#fff",
        p: 2,
        borderRadius: 2,
        maxWidth: 480,
        height: 'auto',
      }}
    >
      {/* Header */}
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
        <Box
          sx={{
            background: "linear-gradient(to bottom, #fff, #70AA2C)",
            p: 1,
            borderRadius: 1,
            color: "#fff",
          }}
        >
          <Typography>{offerData?.teamKey} To Win</Typography>
        </Box>
        <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
          <img
            src={offerData?.sponsorDetails?.logoUrl}
            alt="Sponsor"
            style={{ width: 31, height: 28, borderRadius: "50%" }}
          />
          <img
            src={ACCEPTED}
            alt="Accepted"
            style={{ width: 13, height: 12 }}
          />
          <img
            src={IC_RABBETUSER_LOGO}
            alt="Rabbet"
            style={{ width: 12, height: 22 }}
          />
        </Box>
      </Box>

      {/* Main Content */}
      <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
        <Box sx={{ flex: 3 }}>
          <Typography fontWeight={700} fontSize={24} color="#70AA2C">
            You just won!
          </Typography>
          <Typography fontWeight={700} fontSize={24}>
            {offerData?.title ?? "--"}
          </Typography>
          <Typography>{offerData?.description ?? "--"}</Typography>
        </Box>
        <Box
          sx={{
            flex: 2,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            src={
              offerData.promoType === "Winner"
                ? offerData?.sponsorDetails?.imageUrl
                : offerData?.userChoiceOutcomePrediction?.leftOptionImageUrl
            }
            alt="Reward"
            style={{ width: "80%", height: "90%", objectFit: "cover" }}
          />
        </Box>
      </Box>

      {/* Redemption Code */}
      <Box
        sx={{
          background: "linear-gradient(to right, #70AA2C, #6faa2c77)",
          borderRadius: 1,
          textAlign: "center",
          py: 1,
          mb: 2,
        }}
      >
        <Typography fontWeight={600}>One-time Redemption Code</Typography>
        <Typography
          fontWeight={700}
          variant="h6"
          sx={{ userSelect: "text" }}
        >
          {offerData?.winPromoCode ?? "PROMO!@#$"}
        </Typography>
      </Box>

      {/* Share Button */}
      <Box sx={{ textAlign: "center", mb: 2 }}>
        <Button
          variant="contained"
          sx={{
            background: "linear-gradient(to right, #EF4B4B, #EF4B4B88)",
            color: "#fff",
            textTransform: "none",
          }}
          startIcon={
            <img
              src={IC_SHARE_REFERRAL}
              alt="Share"
              style={{ width: 20, height: 20 ,color:COL_WHITE }}
              color="white"
            />
          }
        >
          Share
        </Button>
      </Box>

      {/* Expiry Info */}
      <Typography
        variant="body2"
        textAlign="center"
        sx={{ color: "#ccc", mx: "auto", maxWidth: "70%" }}
      >
        Offer expires and will be removed from your feed on <strong>{expiredDate}</strong>. Please use before then.
      </Typography>
    </Box>
  );
};

export default RedemptionCard;
